module.exports = __webpack_public_path__ + "static/preview-summer-catchers@2x-38aaf8765e25846b75cee27aa185f0c3.jpg";